export default __webpack_public_path__ + "static/media/flag.04f3bfcf.svg";